import { bindable} from 'aurelia-framework';
import { FeeCalculationValue } from '../../models/feeCalculationValue';
import { FeeCalculationType } from '../../models/feeCalculationType';
import numeral from 'numeral';

export class TieredFeesDisplay
{
	@bindable allowFeesOnAutopays: boolean;
	@bindable feeValues: FeeCalculationValue[];
	@bindable isTieredFees: FeeCalculationValue[];
	@bindable formattedConvenienceFee: string;

	getFormattedConvenienceFee(feeCalculationValue: FeeCalculationValue) {
		return feeCalculationValue.feeCalculationType === FeeCalculationType.Percentage
			? `${ numeral(feeCalculationValue.feeValue).format('0.00')}%`
			: numeral(feeCalculationValue.feeValue).format('($0,0.00)');
	};
}
